import React from "react";
import { sort, uniq } from "ramda";
import { GovernySpells, Spell } from "../../../../lib/types";
import { getLearntSpell } from "../../../../lib/commonFunctions";
import SpellPerson from "./SpellPerson";

interface IProps {
  govId?: number;
  spells: GovernySpells;
  spellsLimit: number;
  spellUpgradeAvailable: number;
  magicClosed: boolean;
}

const AvailableSpells = ({
  govId,
  spells,
  spellsLimit,
  spellUpgradeAvailable,
  magicClosed
}: IProps) => (
  <div className="row persons" style={{ minWidth: "90" }}>
    {uniq<number>(sort<Spell>(
      (s1: Spell, s2: Spell) => (s1.buff ? -1 : (s2.buff ? 1 : (s1.damage ? -1 : 1))),
      spells.available
    ).filter((spell: Spell) => !spell.generalSpell).map((spell: Spell) => spell.family))
      .map((familyId: number) => {
        const learntSpell = getLearntSpell(spells.learnt, spells.available, familyId);
        const spell = learntSpell
          ? spells.available.find((s: Spell) => s.id === learntSpell)
          : spells.available
            .find((s: Spell) => s.family === familyId && s.level === 1);
        return (
          spell && <div className="col-sm-4 col-sm-1-9 col-md-1-9" style={{ paddingLeft: "5px", paddingRight: "5px" }}>
            <SpellPerson
              govId={govId}
              spell={spell}
              learnt={!!learntSpell}
              available={!learntSpell && spells.learnt.length < spellsLimit
              && !spell.blocked}
              upgradeable={spell.level < 3 && !!learntSpell && !!spellUpgradeAvailable}
              isPlanned={magicClosed && spells.cast.some((s: any) => s.id === spell.id)}
            />
          </div>
        )
      })}
  </div>
)

export default AvailableSpells;
